/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Terms_TitleInputs */

const es_cap_err_terms_title = /** @type {(inputs: Cap_Err_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condiciones`)
};

const gl_cap_err_terms_title = /** @type {(inputs: Cap_Err_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condicións`)
};

const en_cap_err_terms_title = /** @type {(inputs: Cap_Err_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Cap_Err_Terms_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_terms_title = /** @type {((inputs?: Cap_Err_Terms_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Terms_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_terms_title(inputs)
	if (locale === "en") return en_cap_err_terms_title(inputs)
	return es_cap_err_terms_title(inputs)
});